import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { modalButtonConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createEnumSchema } from '../../../lib/utils/validations/enum-validation'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'
import ValidationButtons from '../../elements/validation-buttons'
import { PdfChoicesInput, PdfFormat, pdfFormatEnumMapping, RadioChoiceProps } from './utils'

type Props = {
  className?: string
  submitText?: string
  handleSubmit: (values: PdfChoicesInput) => void
  onCancel: () => void
}

const formSchema: ZodType<PdfChoicesInput> = z.object({
  format: createEnumSchema({ fieldName: 'format', enumType: PdfFormat })
})

const RadioChoice = ({ value: selectedValue, ...props }: RadioChoiceProps<PdfFormat>) => {
  return (
    <div className={'flex flex-col gap-4'}>
      {Object.values(PdfFormat).map((value) => (
        <ControlledRadioInput
          {...props}
          key={value}
          label={pdfFormatEnumMapping[value]}
          checked={selectedValue === value}
          onCheck={() => props.onChange(value)}
        />
      ))}
    </div>
  )
}

export function AffectedStaffsPdfChoicesForm({
  className,
  submitText,
  handleSubmit,
  onCancel
}: Props) {
  const form = useForm<PdfChoicesInput>({
    resolver: zodResolver(formSchema)
  })

  const onSubmit = (values: PdfChoicesInput) => {
    handleSubmit(values)
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className={'flex flex-col gap-3'}>
        <div className={cn('flex flex-col gap-4', className)}>
          <Typography variant={'label-semibold'}>Choisir le modèle : *</Typography>
          <FormField
            control={form.control}
            name={'format'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <RadioChoice {...field} />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons
          hasBorderTop
          buttonsConfig={modalButtonConfig({
            onCancel,
            confirmText: submitText,
            onConfirm: handleSubmit
          })}
        />
      </form>
    </Form>
  )
}
